import { routes } from '@platform/core/lib/routes';
import type { ICrumb } from './ICrumb';
import type { ICrumbsInput } from './ICrumbsInput';
import { modulesLink } from './modulesLink';

/**
 * Рівні крихт (UIUX layout/breadcrumbs, прототип v4): «Робочий простір › Група › Модуль (› Таблиця) (› Запис)» (підгрупа — однією крихтою
 * «Управління › Розвиток», як CRUMB_CAT прототипу), на системних
 * сторінках — «Робочий простір › Сторінка». Кожен рівень, крім останнього, — посилання: робочий простір → Головна, група й підгрупа →
 * «Усі модулі», відфільтровані за групою, модуль → повернення до модуля (батьківський модуль дочірньої таблиці — відкриття модуля), таблиця →
 * її список. Системні модулі (Адміністрування, Налаштування) додають
 * свою назву другим рівнем: «Простір › Налаштування › Форми». Чиста функція.
 */
export function crumbsOf(input: ICrumbsInput): ICrumb[] {
  const { module, placement, table, section, record, page, label, system } = input;
  const crumbs: ICrumb[] = [{ label: input.workspaceName, to: routes.home() }];
  if (!module) {
    if (system) crumbs.push({ label: system.label, to: system.to });
    if (page) crumbs.push({ label: page });
    return finish(crumbs);
  }
  if (placement) {
    // прототип v4 CRUMB_CAT: підгрупа — одна крихта «Управління › Розвиток» (посилання на «Усі модулі» підгрупи)
    crumbs.push(placement.subgroup
      ? { label: `${label(placement.group.crumb)} › ${label(placement.subgroup.label)}`, to: modulesLink(placement.subgroup.key) }
      : { label: label(placement.group.crumb), to: modulesLink(placement.group.key) });
  }
  // прототип v4: крихта модуля повертає до модуля (page:'module' — те саме подання й відкриті групи меню), а батьківський модуль дочірньої
  // таблиці відкриває модуль заново (openModule)
  crumbs.push({ label: module.label, to: table ? routes.module(module.key) : routes.moduleReturn(module.key) });
  if (table) crumbs.push({ label: table.label, to: routes.list(module.key, table.key) });
  if (section) crumbs.push({ label: section });
  if (record) crumbs.push({ label: record });
  return finish(crumbs);
}

/** Останній рівень — поточна сторінка, без посилання. */
function finish(crumbs: ICrumb[]): ICrumb[] {
  const last = crumbs[crumbs.length - 1];
  return last ? [...crumbs.slice(0, -1), { label: last.label }] : crumbs;
}
